import React from 'react'
import { ColumnProps } from 'antd/lib/table'
import { Tooltip } from 'antd'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import { ApplicationState } from 'src/store'
import { currencyMask } from 'src/components/Formik'
import { R14Data } from 'src/store/ducks/reports/types'
import * as Css from './styles'

function getRowKey(value: any, index: number) {
  return `${value.request_ticket_receipt_number}${value.user_id}${index}`
}

function TooltipText({ text }: { text: string }) {
  return (
    <Tooltip title={text}>
      <Css.Text>{text}</Css.Text>
    </Tooltip>
  )
}

export function TableItems({ items }: { items: R14Data[] }) {
  const { t } = useTranslation()
  const {
    me: {
      user: { tenant_id }
    }
  } = useSelector((state: ApplicationState) => ({
    me: state.me
  }))

  const showTenantFields = [597990758089, 559042084949].includes(+tenant_id)
  const columns: ColumnProps<unknown>[] = [
    {
      title: 'Cod',
      dataIndex: 'request_ticket_receipt_number',
      width: 50,
      align: 'center'
    },
    {
      align: 'center',
      dataIndex: 'request_number',
      title: 'Solic.',
      width: 50
    },
    {
      dataIndex: 'title',
      ellipsis: true,
      render: (text: string) => <TooltipText text={text} />,
      title: t('web.report.10.data.title')
    },
    ...(showTenantFields
      ? [
          {
            dataIndex: 'status',
            render: (status: string) => (
              <span style={{ whiteSpace: 'nowrap' }}>
                {t(`common.status.unified.${status}`.toLowerCase())}
              </span>
            ),
            title: t('web.report.10.data.ticket_status'),
            width: 105
          }
        ]
      : [{}]),
    {
      dataIndex: 'datetrunc',
      render: (value: number) => moment.unix(value).utc().format('DD/MM/YYYY'),
      title: t('web.report.1.data.date'),
      width: 75
    },
    ...(showTenantFields
      ? [
          {
            dataIndex: 'checked_on',
            render: (value: number | null) =>
              Boolean(value)
                ? moment.unix(value).utc().format('DD/MM/YYYY')
                : '',
            title: t('web.tree.flows.conferences.title'),
            width: 90
          }
        ]
      : [{}]),
    {
      dataIndex: 'service',
      ellipsis: true,
      render: (text: string) => <TooltipText text={text} />,
      title: t('web.policies.limits.service')
    },
    {
      dataIndex: 'cost_center',
      ellipsis: true,
      render: (text: string) => <TooltipText text={text} />,
      title: t('web.assignment.sharing.form.cost-center.title')
    },
    {
      align: 'center',
      dataIndex: 'total',
      render: (value: number) =>
        currencyMask({ formatStr: true, precision: 2, value }).maskedValue,
      title: t('common.value'),
      width: 75
    },
    {
      align: 'center',
      dataIndex: 'justification',
      render: (text: string) => <TooltipText text={text} />,
      title: t('web.receipt.form.justification.title'),
      width: 125
    }
  ]
  return (
    <Css.Table
      rowKey={getRowKey}
      className="table-striped"
      columns={columns}
      dataSource={items}
      pagination={false}
    />
  )
}

export function Total({ value }: { value: number }) {
  const { t } = useTranslation()
  return (
    <Css.Total>
      {t('web.report.12.data.total')}
      {': '}
      {currencyMask({ formatStr: true, precision: 2, value }).maskedValue}
    </Css.Total>
  )
}
